import { render, staticRenderFns } from "./homeTwo.vue?vue&type=template&id=04dd43fa&scoped=true"
import script from "./homeTwo.vue?vue&type=script&lang=js"
export * from "./homeTwo.vue?vue&type=script&lang=js"
import style0 from "./homeTwo.vue?vue&type=style&index=0&id=04dd43fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dd43fa",
  null
  
)

export default component.exports